module.exports = __webpack_public_path__ + "static/media/drone-boat-warp-flipped-fullspeed-v2-shrunk.3df6403e.mp4";